import type { IPushBridge } from './ports/IPushBridge'
import type { IPushDeviceGateway } from './ports/IPushDeviceGateway'

// Сценарий: продавец выключил пуши в приложении — устройство выключается в notifire, токен FCM
// остаётся (включение зарегистрирует его снова). Системное разрешение не трогается: приложение его
// отозвать не может.
export class DisablePushDevice {
  constructor(
    private readonly bridge: IPushBridge,
    private readonly gateway: IPushDeviceGateway,
  ) {}

  async execute() {
    if (!this.bridge.isAvailable()) return

    const current = await (this.bridge.currentToken() ?? this.bridge.getToken())
    await this.gateway.unregister(current.token)
  }
}
